import { useBaseComponent } from "@shared/base/hooks/useBaseComponent";
import { usePageViewTimer } from "@shared/hooks/usePageViewTimer";
import { Button } from "@shared/ui/button";
import { Tabs } from "@shared/ui/tabs";
import { FileUp } from "lucide-react";
import { useState } from "react";
import { AddBulkMeters } from "./AddBulkMeters";
import MeterInventoryList from "./MeterInventoryList";
import MeterRetiredList from "./MeterRetiredList";
import { UsedMeters } from "./UsedMeters";
const MeterInventoryManager = () => {
  const { renderError } = useBaseComponent();

  const [isBulkUploadOpen, setIsBulkUploadOpen] = useState(false);
  const handleBulkUpload = () => {
    setIsBulkUploadOpen(true);
    // Create a hidden file input element
  };
  usePageViewTimer({ pageName: "MX Inventory" });

  const tabComponents = {
    "in-stock": {
      label: "In Stock",
      shortLabel: "Stock",
      component: <MeterInventoryList />,
    },
    usedMeters: {
      label: "Used Meters",
      shortLabel: "used-meters",
      component: <UsedMeters />,
    },
    disposed: {
      label: "Disposed",
      shortLabel: "Disposed",
      component: <MeterRetiredList />,
    },
  };

  const urlMapping = {
    "in-stock": "stock",
    disposed: "disposed",
    usedMeters: "used-meters",
  };

  return (
    <div className="w-full px-4 space-y-6">
      {renderError()}

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h2 className="page-title">Meter Inventory Management</h2>
          <p className="page-subtitle">
            Monitor, track, and manage the full lifecycle of meter inventory
            across locations.
          </p>
        </div>

        <div className="flex gap-2">
          <Button onClick={handleBulkUpload}>
            <FileUp className="mr-2 h-4 w-4" />
            Bulk Add Meters
          </Button>
        </div>
      </div>
      <AddBulkMeters
        isOpen={isBulkUploadOpen}
        onClose={() => {
          setIsBulkUploadOpen(false);
        }}
      />

      <Tabs
        defaultValue="in-stock"
        urlMapping={urlMapping}
        tabComponents={tabComponents}
        tabsListClassName="grid grid-cols-3 gap-2"
        className="space-y-4"
      />
    </div>
  );
};

export default MeterInventoryManager;
